
function TitlePage({Title}){
    return(<h3 className="text-3xl font-medium text-gray-700" > {Title} </h3>)
}

export default TitlePage